import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';
import {
  defaultAuthState,
  loadAuthState,
  type AuthState,
  type AuthUser,
} from '@/store/authStorage';

interface LoginPayload {
  token: string;
  user: AuthUser;
}

const initialState: AuthState = loadAuthState();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<LoginPayload>) {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    logout() {
      return defaultAuthState;
    },
  },
});

export const authActions = authSlice.actions;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectCurrentUser = (state: RootState) => state.auth.user;

export default authSlice.reducer;
